import { useRef } from "react";
import { type HyperTableContextValue } from "./types";

export function useHyperTableContext<Entity>() {
  return useRef<HyperTableContextValue<Entity> | null>(null);
}
